import React from 'react';

import { TUploadStatus } from '@/shared/models/uploaded-file';
import { DocStatusLabel } from '@src-common/view/components/DocsList';

import { Tag } from '../Tag';

import s from './styles.module.css';

const INTENT_BY_STATUS: Record<TUploadStatus, 'success' | 'warning' | 'danger'> = {
  approved: 'success',
  pending: 'warning',
  rejected: 'danger',
  expired: 'danger',
};

const DocStatusBadge = ({ status }: { status: TUploadStatus }) => (
  <span className={s.badge} data-test-id="doc-status-badge">
    <Tag intent={INTENT_BY_STATUS[status]}>
      <DocStatusLabel status={status} />
    </Tag>
  </span>
);

export { DocStatusBadge };
